import { EVENT_TYPES } from './event-types'

export default {
  ORDER_DECLINED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'order_declined',
  },
  ORDER_DECLINED_REDIRECT_TO_MERCHANT: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'order_decline_back_to_merchant_clicked',
  },
}
